<template>
  <div>
    <div>
      <a-modal
        :dialog-style="{ top: '20px' }"
        :title="title"
        :visible="isVisible"
        :destroyOnClose="true"
        :maskClosable="false"
        width="50%"
        @ok="handleOk"
        @cancel="close"
      >
        <div class="projectManageModal">
          <a-form-model
            ref="formRef"
            :model="form"
            labelAlign="right"
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            :rules="rules"
          >
            <a-row>
              <a-col :span="24">
                <a-form-model-item
                  label="对应项目"
                  :labelCol="rowLabel"
                  :wrapperCol="rowWrapper"
                  prop="projectName"
                >
                  <p
                    class="choosePerson"
                    :class="{ 'disabled': isDisabled }"
                    @click="openModal('project')"
                  >{{ form.projectName || '选择项目' }}</p>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-model-item
                  label="采购单"
                  :labelCol="rowLabel"
                  :wrapperCol="rowWrapper"
                  prop="purchaseName"
                >
                  <p
                    class="choosePerson"
                    @click="openModal('purchaseName')"
                    :style="{
                      color: form.purchaseName ? '#333' : '#ccc'
                    }"
                  >{{ form.purchaseName || '选择采购单' }}</p>
                </a-form-model-item>
                <!-- <a-form-model-item
                  label="采购单"
                  :labelCol="rowLabel"
                  :wrapperCol="rowWrapper"
                  prop="purchaseName"
                >
                  <a-select
                    @change="subjectCahnge"
                    @dropdownVisibleChange="dropdownVisibleChanged"
                    show-search
                    v-model="form.purchaseName"
                    placeholder="请选择"
                  >
                    <a-select-option
                      v-for="(item,index) in procurement"
                      :key="index"
                      :customerName="item.suppliersName"
                      :customerId="item.supplierId"
                    >{{item.subject}}</a-select-option>
                  </a-select>
                </a-form-model-item>-->
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-model-item
                  label="供应商"
                  :labelCol="rowLabel"
                  :wrapperCol="rowWrapper"
                  prop="customerName"
                >
                  <a-input
                    read-only
                    v-model="form.customerName"
                    @click="openModal('supplier')"
                    class="choosePerson"
                    :class="disselectSupplier ? 'readOnly' : ''"
                    style="cursor: pointer;"
                  />
                  <!-- <p class="choosePerson" @click="openModal('supplier')">{{ form.customerName || '选择供应商' }}</p> -->
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row :span="24">
              <a-col>
                <a-form-model-item label="付款计划/记录" :labelCol="rowLabel" :wrapperCol="rowWrapper">
                  <a-table
                    v-if="patData && patData.length > 0"
                    class="myTable"
                    bordered
                    size="small"
                    :columns="planColumns"
                    :data-source="patData"
                    :pagination="tablePagination"
                    @change="pageChange"
                    :rowKey="(record,index)=>{return index}"
                    style="width: 100%;"
                  >
                    <template slot="type" slot-scope="text, record">
                      <span v-if="record.payType === 0">付款计划</span>
                      <span v-if="record.payType === 1">付款记录</span>
                    </template>
                    <template slot="parentIdSlot" slot-scope="text, record">
                      <!--
                      :disabled="isDisabled()"-->
                      <a-checkbox
                        :disabled="isDisabled"
                        :checked="record.id === form.planRecordId ? true : false"
                        @change="checked => checkChange(checked, record.id)"
                      >完成</a-checkbox>
                    </template>
                  </a-table>
                  <!-- <a-select
                    @change="payCahnge"
                    @dropdownVisibleChange="dropdownVisibleChange"
                    show-search
                    v-model="ispat"
                    placeholder="请选择"
                  >
                    <a-select-option v-for="(item,index) in patDatas" :key="index">{{ item }}</a-select-option>
                  </a-select>-->
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-model-item
                  label="发票内容"
                  prop="invoiceContent"
                  :labelCol="rowLabel"
                  :wrapperCol="rowWrapper"
                >
                  <a-input placeholder="输入发票内容" v-model="form.invoiceContent" />
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-model-item label="收票日期" prop="invoiceDate">
                  <a-date-picker
                    valueFormat="YYYY-MM-DD"
                    v-model="form.invoiceDate"
                    style="width: 100%;"
                  />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item label="票据类型" prop="invoiceType" style="width: 100%;">
                  <a-select v-model="form.invoiceType" @change="ticketReceiptClick">
                    <a-select-option
                      v-for="(item, index) in billTypeList"
                      :key="index"
                      :value="item.label"
                    >{{ item.value }}</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-model-item label="发票号码" prop="payMoney">
                  <a-input placeholder="输入发票号码" v-model="form.invoiceNum" style="width:100%" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item label="经手人">
                  <p
                    class="choosePerson"
                    style="width:100%"
                    @click="openPerson('handled')"
                  >{{ nameObj.handledBy || this.getLocal()}}</p>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-model-item label="税率" prop="taxRate">
                  <a-input
                    placeholder="输入税率"
                    @blur="isTaxs"
                    v-model="form.taxRate"
                    style="width: 90%"
                  />
                  <span>%</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item label="票据金额" prop="invoiceMoney">
                  <a-input-number
                    placeholder="输入票据金额"
                    v-model="form.invoiceMoney"
                    :step="0.01"
                    :min="0"
                    :precision="2"
                    style="width:100%;"
                    @blur="isTaxes"
                  />
                  <!-- <a-input-number
                    placeholder="输入票据金额"
                    style="width:91%"
                    v-model="form.invoiceMoney"
                    :step="0.01"
                    :parser="value =>value.match(/^[0-9]*\.([0-9]{0,2})|^[0-9]*/)[0]"
                  @blur="isTaxes" />-->
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-model-item label="是否含税">
                  <a-tooltip placement="topLeft" title="进顶税金计算说明：计算进项税时，进项税金=开票金额*税率/(1+税率)">
                    <a-icon
                      type="warning"
                      theme="filled"
                      style="color: #ECD5A2; padding: 0px 6px;"
                    />
                  </a-tooltip>
                  <a-radio-group
                    name="radioGroup"
                    :default-value="1"
                    v-model="form.includingTax"
                    @change="isRadioGroups"
                    :disabled="isincludingTax"
                  >
                    <a-radio :value="0">计算</a-radio>
                    <a-radio :value="1">不计算</a-radio>
                  </a-radio-group>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item label="进顶税金">
                  <span>{{form.taxes}}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-model-item label="是否付款">
                  <a-radio-group name="radioGroup" @change="radioChange" v-model="form.moneyStatus">
                    <a-radio :value="0">未付</a-radio>
                    <a-radio :value="1">已付</a-radio>
                  </a-radio-group>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-model-item label="备注" :labelCol="rowLabel" :wrapperCol="rowWrapper">
                  <a-textarea :auto-size="{ minRows: 3, maxRows: 10 }" v-model="form.remark" />
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-model-item label="抄送人" :labelCol="rowLabel" :wrapperCol="rowWrapper">
                  <p
                    class="choosePerson"
                    @click="openPerson('user', form.userName, form.userId)"
                  >{{ form.userName || '点击选择抄送人' }}</p>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-model-item label="上传附件" :labelCol="rowLabel" :wrapperCol="rowWrapper">
                  <upload-attachment ref="uploadRef" :val-name="valName" />
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model>
        </div>
        <template #footer>
          <a-button @click="close" style="background-color:#F2F2F2">取消</a-button>
          <a-button type="primary" :loading="loading" @click="handleOk">保存</a-button>
        </template>
      </a-modal>
    </div>
    <div>
      <personnel
        :visible="personVisible"
        :chooseData="chooseData"
        :isOnce="isOnce"
        @close="personClose"
        @success="personSuccess"
      />
    </div>
    <div>
      <publicDialog
        :title="publicDia.title"
        :dialog-visible="publicDia.visible"
        :component-name="publicDia.comName"
        :projectId="publicDia.projectId"
        @logSuccess="publicDialogSucc"
        @cancel="handleClose"
      />
    </div>
    <a-modal v-model="visible" title="是否保存" @ok="confirmOk" @cancel="cancel">
      <p>未关联付款计划/记录，是否继续保存？</p>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'
import publicDialog from '../../../components/modelDialog/publicDialog.vue'
import personnel from '../../../components/personnel'
import { taxComputation } from '../../../utils/common'
import uploadAttachment from '../../common/Upload.vue'

export default {
  name: 'addEdit',
  components: { publicDialog, personnel, uploadAttachment },
  props: {
    title: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  provide () {
    return {
      formData: this
    }
  },
  computed: {
    isVisible: {
      get () {
        return this.dialogVisible
      },
      set () {
        this.close()
      }
    }
  },
  data () {
    return {
      visible: false,
      disselectSupplier: false, // 采购单新建时供应商不允许选择
      payments: false,
      ischecked: false,
      ischeckeds: false,
      isOnce: false,
      loading: false,
      patData: [],
      patDatas: [],
      tablePagination: {
        pageSize: 5,
        pageNum: 1,
        total: 0,
        pageSizeOptions: ['5', '10', '15'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        showQuickJumper: true, // 是否可以快速跳转至某页
        showSizeChanger: true // 是否可以改变pageSize
      },
      planColumns: [
        {
          width: '20%',
          align: 'center',
          title: '类型',
          scopedSlots: { customRender: 'type' }
        },
        {
          width: '20%',
          align: 'center',
          title: 'ID',
          dataIndex: 'id'
        },
        {
          width: '20%',
          align: 'center',
          title: '付款日期',
          dataIndex: 'payDate'
        },
        {
          width: '20%',
          align: 'center',
          title: '付款金额',
          dataIndex: 'payMoney'
        },
        // {
        //   width: '24%',
        //   align: 'center',
        //   title: '计划冲销额',
        //   dataIndex: 'backCxMoney'
        // },
        {
          width: '20%',
          align: 'center',
          title: '关联',
          scopedSlots: { customRender: 'parentIdSlot' }
        }
      ],
      ispat: '',
      personVisible: false,
      personData: {}, // 选择人员数据
      nameObj: {},
      dataValue: {},
      rules: {
        projectName: [{ required: true, message: '请选择对应项目', trigger: ['change', 'blur'] }],
        customerName: [{ required: true, message: '请选择对应供应商', trigger: ['change', 'blur'] }],
        invoiceContent: [{ required: true, message: '请输入发票内容', trigger: 'blur' }],
        purchaseName: [{ required: true, message: '请选择采购单', trigger: 'change' }],
        invoiceDate: [{ required: true, message: '请选择时间', trigger: 'change' }],
        invoiceType: [{ required: true, message: '请选择票据类型', trigger: 'change' }],
        invoiceMoney: [{ required: true, message: '请输入票据金额，最多可保留两位小数！', trigger: 'blur' }],
        taxRate: [{ required: true, message: '请输入税率', trigger: 'blur' }]
      },
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
      rowLabel: { span: 3 },
      rowWrapper: { span: 19 },
      isRecords: false,
      uploadFileList: [],
      customerId: '',
      purchaseId: '',
      payType: 0,
      billTypeList: [],
      isProjectType: true,
      billTypeObj: {},
      valName: 'uploadFileList',
      openPersonType: '',
      publicDia: {
        title: '',
        visible: false,
        comName: '',
        projectId: ''
      },
      periods: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      form: {
        taxes: '',
        invoiceDate: moment().format('YYYY-MM-DD'),
        moneyStatus: 0,
        includingTax: 1 // 是否含税
      },
      procurement: [], // 采购单选择
      chooseData: {}, // 选择的人员数据
      isincludingTax: false,
      isDisabled: false
    }
  },
  watch: {
    isRecords: {
      handler (newVal, oldVal) {
        if (newVal) {
          this.form.payDateActual = moment().format('YYYY-MM-DD')
        } else {
          this.form.payDateActual = null
        }
      },
      immediate: true
    }
  },
  mounted () {
    this.getLocal()
    this.getmoneyStatus()
    const { billTypeList, billTypeObj } = this.$store.state.account.dictData
    this.billTypeList = billTypeList
    this.billTypeObj = billTypeObj
  },
  methods: {
    moment,
    // isDisabled () {
    //   return this.title !== `[新建]-${this.$tree([], 'financialManage/ticketReceiptRecord/index')}`
    // },
    pageChange (pageVal) {
      this.tablePagination.pageNum = pageVal.current
      this.tablePagination.pageSize = pageVal.pageSize
    },
    showModal () {
      this.visible = true
    },
    cancel () {
      this.visible = false
      this.loading = false
    },
    confirmOk (e) {
      // console.log(e)
      this.visible = false
      this.submitReq()
    },
    ticketReceiptClick (e) {
      // console.log(e, '========')
      if (e === '406') {
        this.$set(this.form, 'includingTax', 1)
        this.$set(this.form, 'taxRate', 0)
        this.$set(this.form, 'taxes', '')
        this.isincludingTax = false
      } else if (e === '175') {
        this.$set(this.form, 'includingTax', 0)
        this.$set(this.form, 'taxRate', '')
        this.$set(this.form, 'taxes', '')
        this.isincludingTax = true
      } else {
        this.isincludingTax = false
        this.$set(this.form, 'taxRate', '')
        this.$set(this.form, 'taxes', '')
      }
    },
    judgment () {
      if (!this.nameObj.handledBy) {
        this.form.handledBy = this.getLocal()
      } else {
        this.form.handledBy = this.nameObj.handledBy
      }
    },
    getmoneyStatus () {
      console.log('ispat =>', this.ispat)

      if (this.ispat !== '') {
        if (this.payType === 0) {
          this.$set(this.form, 'moneyStatus', 0)
        } else {
          this.$set(this.form, 'moneyStatus', 1)
        }
      } else {
        this.$set(this.form, 'moneyStatus', 0)
      }
    },
    dateFormat (row) {
      if (row) {
        let date = row.split(' ')[0]
        let year = date.split('-')[0]
        let month = date.split('-')[1]
        let day = date.split('-')[2]
        return year + '-' + month + '-' + day
      }
    },
    procurementSelect () {
      if (this.form.projectId) {
        this.$get('/purchase/getByProjectId', { projectId: this.form.projectId, purchaseSource: 0 }).then(res => {
          res.data.data.rows.forEach(item => {
            item.subject = `${item.subject}(采购单号：${item.code}， 创建人：${item.creator}，状态：${item.status === 0 ? '执行中' : item.status === 1 ? '结束' : '意外中止'})`
          })
          this.procurement = res.data.data.rows
        })
      } else {
        this.$message.warning('请选择项目')
      }
    },
    payCahnge (val) {
      // console.log('val =>', this.patData[val].payMoney)
      this.form.planRecordId = this.patData[val].id
      this.$set(this.form, 'invoiceMoney', this.patData[val].payMoney)
      this.payType = this.patData[val].payType
      this.getmoneyStatus()
    },
    checkChange (e, idVal) { // 计划里的列可勾选完成
      let pId = this.form.planRecordId
      // console.log(idVal, pId, '================')
      this.planIdArr = []
      this.patData.forEach(r => {
        if (r.id === idVal && r.id !== pId) {
          // r.backStatus = 1
          this.planIdArr = [idVal]
          this.$set(this.form, 'invoiceMoney', r.payMoney)
        } else {
          // r.backStatus = 0
        }
      })
      this.$set(this.form, 'planRecordId', this.planIdArr.join(','))
    },
    isPatData (patData) {
      console.log('patData =>', patData)

      if (patData) {
        this.patDatas = []
        patData.forEach(item => {
          let value1 = ''
          if (item.payType === 0) value1 = '【付款计划】'
          else value1 = '【付款记录】'
          let value2 = ''
          if (item.payInvoice === 0) value2 = '(未开票)'
          else if (item.payInvoice === 1) value2 = '(已开票)'
          else value2 = '(无需开票)'
          let value3 = value1 + item.payDate + '￥' + item.payMoney + value2
          this.patDatas.push(value3)
        })
      }
    },
    subjectCahnge (val, option) {
      this.$set(this.form, 'purchaseName', this.procurement[val].subject)
      this.$set(this.form, 'purchaseId', this.procurement[val].id)
      this.$set(this.form, 'customerName', option.data.attrs.customerName)
      this.$set(this.form, 'customerId', option.data.attrs.customerId)
      this.dropdownVisibleChange()
      // this.$get('/invoice/serachPlanRecord', {purchaseId: this.form.purchaseId, type: 0}).then(res => {
      //   this.patData = res.data.data
      //   // console.log('res.data.data =>', res.data.data.rows)
      //   this.isPatData(this.patData)
      // })
    },
    dropdownVisibleChange (e) {
      // let maslist = {
      //   customerId: this.form.customerId,
      //   type: 0
      // }
      // if (this.form.purchaseName) {
      //   maslist.purchaseId = this.form.purchaseId
      // }
      if (this.form.purchaseId && this.form.purchaseId !== '') {
        this.$get('/invoice/serachPlanRecord', { purchaseId: this.form.purchaseId, type: 0 }).then(res => {
          this.patData = res.data.data
          // console.log('res.data.data =>', res.data.data.rows)
          // this.isPatData(this.patData)
        })
      } else {
        this.$message.warning('请先选择采购单！')
      }

      // if (maslist.customerId !== null && maslist.customerId !== '' && maslist.customerId !== undefined) {
      //   // this.$get('/invoice/serachPlanRecord', {...maslist}).then(res => {
      // }
    },
    isTaxs (val) {
      if (this.form.invoiceMoney && this.form.includingTax === 0) {
        this.form.taxes = taxComputation(this.form.invoiceMoney, val.target.value)
      }
    },
    isTaxes (e) {
      if (this.form.taxRate && this.form.includingTax === 0) {
        this.form.taxes = taxComputation(e.target.value, this.form.taxRate)
      }
    },
    isRadioGroups (val) {
      if (val.target.value === 0 && this.form.taxRate && this.form.invoiceMoney) {
        this.form.taxes = taxComputation(this.form.invoiceMoney, this.form.taxRate)
      } else if (val.target.value === 1) {
        this.form.taxes = ''
      }
    },
    personClose () {
      this.personVisible = false
    },
    publicDialogSucc (data, typeVal) {
      if (typeVal === 'projectManage') {
        this.$set(this.form, 'projectName', data.subject)
        this.$set(this.form, 'projectId', data.id)
        if (data.customerType === 2) {
          this.$set(this.form, 'customerName', data.mainCustomer)
          this.$set(this.form, 'customerId', data.mainCustomerId)
        } else {
          this.$set(this.form, 'customerName', null)
          this.$set(this.form, 'customerId', null)
        }
        // this.procurementSelect()
        this.restProject()
        this.$refs.formRef && this.$refs.formRef.clearValidate('projectName')
        // this.form.projectName = data.subject
        // this.form.projectId = data.id
      } else if (typeVal === 'purchaseNote') {
        this.$set(this.form, 'purchaseName', data.subject)
        this.$set(this.form, 'purchaseId', data.id)
        this.dropdownVisibleChange()
        this.$refs.formRef && this.$refs.formRef.clearValidate('purchaseName')
      } else if (typeVal === 'disselect') {
        this.disselectSupplier = true
      } else if (typeVal === 'purchase/purchaseNote') {
        this.$set(this.form, 'purchaseName', data.subject)
        this.$set(this.form, 'purchaseId', data.id)
        this.$set(this.form, 'customerName', data.suppliersName)
        this.$set(this.form, 'customerId', data.supplierId)
        this.dropdownVisibleChange()
        this.$refs.formRef && this.$refs.formRef.clearValidate('purchaseName')
      } else {
        this.$set(this.form, 'customerId', data.id)
        this.$set(this.form, 'customerName', data.companyName)
        this.customerId = data.id
        this.$refs.formRef && this.$refs.formRef.clearValidate('customerName')
        // this.form.customerId = data.id
        // this.form.customerName = data.companyName
      }
      this.payments = true
      this.resetDialogData()
    },
    restProject () {
      // this.$set(this.form, 'customerName', null)
      // this.$set(this.form, 'customerId', null)
      this.$set(this.form, 'purchaseName', null)
      this.$set(this.form, 'purchaseId', null)
      this.patDatas = []
      this.ispat = ''
      this.getmoneyStatus()
    },
    personSuccess (data, type) {
      var username, userId
      // 单选 和 多选 人员数据
      if (type === 'checkType') {
        data.forEach(item => {
          if (!username) {
            username = item.username
            userId = item.userId
          } else {
            username += ',' + item.username
            userId += ',' + item.userId
          }
        })
      } else if (type === 'radioType') {
        username = data.username
        userId = data.userId
      }
      // 判断数据赋值
      if (this.openPersonType === 'user') {
        this.form.userId = userId
        this.form.userName = username
      } else if (this.openPersonType === 'handled') {
        // this.form.charge = userId
        this.nameObj.handledBy = username
      }
      this.personVisible = false
    },
    openPerson (type, name, id) {
      this.openPersonType = type
      // 抄送人为多选
      if (type === 'user') {
        this.isOnce = false
        this.chooseData = { userId: id, userName: name }
      } else {
        this.isOnce = true
      }
      this.personVisible = true
      // this.chooseData = { userId: this.dataValue[type + 'Id'], userName: this.dataValue[type + 'Name'], roleId: this.dataValue.checkRoleId, roleName: this.dataValue.checkRoleName }
    },
    openModal (type) {
      if (type === 'project') {
        if (this.isDisabled) return
        this.publicDia.visible = true
        this.publicDia.title = '选择对应项目'
        this.publicDia.comName = 'projectManage'
      } else if (type === 'purchaseName') {
        if (!this.form.projectId || this.form.projectId === '') {
          this.$message.warning('请先选择项目')
          return
        }
        this.publicDia.projectId = this.form.projectId
        this.publicDia.visible = true
        this.publicDia.title = '选择对应采购单'
        this.publicDia.comName = 'purchase/purchaseNote'
      } else {
        if (this.disselectSupplier) return
        this.publicDia.visible = true
        this.publicDia.title = '选择对应供应商'
        this.publicDia.comName = 'purchase/supplier'
      }
    },
    getLocal () {
      let own = localStorage.getItem('USER')
      this.form.dutyPerson = JSON.parse(own).username
      this.form.payOwner = JSON.parse(own).username
      return JSON.parse(own).username
    },
    radioChange (e) {
      console.log(e)
    },
    resetDialogData () {
      this.publicDia.visible = false
    },
    handleOk (val) {
      // console.log(this.form.taxRate, 'this.form.taxRate')
      if (this.isincludingTax && (!this.form.taxRate || this.form.taxRate === '0')) {
        this.$message.warning('专用发票请填写税率')
        return
      }
      this.$refs.formRef.validate((valid) => {
        this.form.type = 0
        if (this.$refs.uploadRef.setCount !== 0) {
          this.form.fileIds = this.uploadFileList
        }
        this.judgment()
        if (!this.ischecked) {
          delete this.form.payDateActual
        }
        if (valid) {
          this.loading = true
          if (this.form.planRecordId === '' || !this.form.planRecordId) {
            this.showModal()
          } else {
            this.submitReq()
          }
        }
      })
    },
    submitReq () {
      if (this.title === `[新建]-${this.$tree([], 'financialManage/ticketReceiptRecord/index')}`) {
        this.form.handledBy = this.getLocal()
        this.$post('/invoice/add', this.form).then(res => {
          if (res.data.status === 1) {
            this.$message.success(res.data.message)
            this.$emit('success')
            this.resetForm()
          } else {
            this.$message.warning(res.data.message)
          }
        }).finally(r => {
          setTimeout(() => {
            this.loading = false
          }, 200)
        })
      } else {
        this.form.updater = this.getLocal()
        delete this.form.createTime
        delete this.form.updateTime
        this.$post('/invoice/update', this.form).then(res => {
          if (res.data.status === 1) {
            this.$message.success(res.data.message)
            this.$emit('success')
            this.resetForm()
          } else {
            this.$message.warning(res.data.message)
          }
        }).finally(r => {
          setTimeout(() => {
            this.loading = false
          }, 200)
        })
      }
    },
    resetForm () {
      this.uploadFileList = []
      this.patDatas = []
      this.patData = []
      this.ispat = ''
      this.projectName = ''
      this.disselectSupplier = false
      this.isDisabled = false
      setTimeout(() => {
        this.form = {
          taxes: '',
          invoiceDate: moment().format('YYYY-MM-DD'),
          moneyStatus: 0,
          includingTax: 1
        }
        this.getmoneyStatus()
      }, 500)
    },
    dropdownVisibleChanged () {
      if (!this.form.projectId || this.form.projectId === '') {
        this.$message.warning('请先选择项目')
      }
    },
    close () {
      this.resetForm()
      this.$emit('close')
    },
    setForm (row, count) {
      if (count === 1) {
        this.form.projectName = row.projectName
        this.form.projectId = row.projectId
        this.form.customerName = row.customerName
        this.form.customerId = row.customerId
        this.form.purchaseName = row.purchaseName
        this.form.purchaseId = row.purchaseId
        this.form.planRecordId = row.id
        this.form.invoiceMoney = row.payMoney
        this.inData(row.id)
      } else {
        this.form = row
        if (this.form.fileIds) {
          // string 转 数组  循环获取附件信息
          let fileList = this.form.fileIds.split(',')
          this.$nextTick(() => {
            this.$refs.uploadRef.getFile(fileList)
          })
        }
        if (this.form.planRecordId) { // 编辑时判断有无关联计划/记录 有关联则禁止修改项目
          this.isDisabled = true
        }
        // console.log('this.form.planRecordId =>', this.form.planRecordId, this.isDisabled)
        this.inData(this.form.planRecordId)
      }
      // this.$get('/payPlan/list', {id: this.form.planRecordId}).then(res => {
      //   // this.patData = res.data.data.rows
      //   let value = res.data.data.rows[0]
      //   if (value) {
      //     let value1 = ''
      //     if (value.payType === 0) value1 = '【付款记录】'
      //     else value1 = '【付款计划】'
      //     let value2 = ''
      //     if (value.payInvoice === 0) value2 = '未开'
      //     else if (value.payInvoice === 1) value2 = '已开'
      //     else value2 = '无需开票'
      //     let value3 = value1 + '—' + value.payDate + '—￥' + value.payMoney + '—' + value2
      //     this.ispat = value3
      //   }
      // })
    },
    inData (id) {
      this.$get('/payPlan/getById', { id: id }).then(res => {
        // this.patData = res.data.data.rows
        let value = res.data.data
        if (value) {
          this.patData = [value]
        }
        // if (value) {
        //   console.log('value =>', value)

        //   let value1 = ''
        //   if (value.payType === 1) value1 = '【付款记录】'
        //   else value1 = '【付款计划】'
        //   let value2 = ''
        //   if (value.payInvoice === 0) value2 = '未开'
        //   else if (value.payInvoice === 1) value2 = '已开'
        //   else value2 = '无需开票'
        //   let value3 = value1 + '—' + value.payDate + '—￥' + value.payMoney + '—' + value2
        //   this.payType = value.payType
        //   this.ispat = value3
        //   this.getmoneyStatus()
        // }
      })
    },
    handleClose () {
      this.publicDia.visible = false
    }
  }
}
</script>

<style lang="less" scoped>
.ant-calendar-picker {
  width: 93%;
}

.ant-form-item {
  display: flex;

  .ant-form-item-label {
    width: 110px;
  }

  .ant-form-item-control-wrapper {
    flex: 1;
  }
}

.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
.disabled {
  cursor: not-allowed;
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
}
</style>



// WEBPACK FOOTER //
// src/views/financialManage/ticketReceiptRecord/addEdit.vue